<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <div class="form-group" >
      <label :for="item.name + '-buttontext'">Button text</label>
      <input :id="item.name + '-buttontext'" class="form-control" type="text"
             v-model="item.button">
    </div>
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// FormBuilderEditorImage.vue?1d8db1a8